/* istanbul ignore file */

export const WIDGET_BREADCRUMB_TYPE = 'breadcrumb';
